var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pvp-btn',{staticClass:"action-link",attrs:{"variant":"clear"},on:{"click":function($event){return _vm.termStore.openTermModal({ code: _vm.code })}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }